import { updatedDiff } from "deep-object-diff"
import _ from "lodash"
import { useFindObjectPropertyId } from "./useFindObjectPropertyId"
import { useFindObjectPropertyTp } from "./useFindObjectPropertyTp"

export const useMutationDataDifference = () => {

    const findPropertyId = useFindObjectPropertyId()
    const findPropertyTp = useFindObjectPropertyTp()

    const getDiff = (oldObject: Record<string, any>, newObject: Record<string, any>, concerveIdField?: boolean, concerveTpField?: boolean) => {
        const result: Record<string, any> = updatedDiff(oldObject, newObject)
        
        const idProp = findPropertyId(newObject)
        const tpProp = findPropertyTp(newObject)
        if (idProp && concerveIdField) {
            result[idProp] = newObject[idProp]
        }

        if (tpProp && concerveTpField) {
            result[tpProp] = newObject[tpProp]
        }

        Object.keys(oldObject).forEach((key) => {
            const oldValue = oldObject[key]
            const newValue = newObject[key]

            if (
                Array.isArray(oldValue) 
                && Array.isArray(newValue) 
                && !_.isEqual(oldValue, newValue) 
                ) {

                
                result[key] = newValue.map((item, index) => {
                    const oldItem = oldValue[index]
                    return { ...oldItem, ...item }
                }).filter((item, index) => {
                    const oldItem = oldValue[index]
                    return !_.isEqual(oldItem, item)
                })

                if (result[key].length === 0) {
                    delete result[key]
                }
            }

            
        })
        
        return result
    }

    return getDiff
}
